import * as FeatherIcons from 'vue-feather-icons';

export default {
    items: [
        {
            name: 'Dashboard',
            type: 'dashboard',
            route: 'dashboard',
            iconClass: 'kt-menu__link-icon flaticon2-graphic',
            color: 'navy',
            group: 'general',
            iconComponent: FeatherIcons.GridIcon,
        },
        {
            name: 'Content',
            children: [
                { name: 'Layouts', route: 'layouts' },
                { name: 'Pages', route: 'pages', type: 'page' },
                { name: 'Panel library', route: 'panels', type: 'panel' },
                // { name: 'Quick Links', route: 'quick_links', type: 'quick_link', shortcut: 'quick_link/_' },
            ],
            iconClass: 'kt-menu__link-icon flaticon2-telegram-logo',
            // iconName: '',
            color: 'navy',
            group: 'general',
            iconComponent: FeatherIcons.LayersIcon,
        },
        {
            name: 'Assets',
            route: 'assets/0',
            type: 'asset',
            iconClass: 'kt-menu__link-icon flaticon2-image-file',
            // iconName: '',
            color: 'navy',
            group: 'general',
            iconComponent: FeatherIcons.ImageIcon,
        },
        {
            name: 'Campaigns',
            route: 'campaigns',
            type: 'campaign',
            iconClass: 'kt-menu__link-icon flaticon2-telegram-logo',
            // iconName: '',
            color: 'navy',
            group: 'general',
            iconComponent: FeatherIcons.SendIcon,
        },

        {

            name: 'Blog',
            children: [
                { name: 'Posts', route: 'news_posts', type: 'news_post' },
                { name: 'Categories', route: 'news_categories', type: 'news_category' },
            ],
            iconClass: 'kt-menu__link-icon flaticon2-checking',
            // iconName: '',
            color: 'navy',
            group: 'seventytwo',
            iconComponent: FeatherIcons.FileTextIcon,
        },
        {
            name: 'Work',
            ...{ name: 'Work', route: 'case_studies', type: 'case_study' },
            iconClass: 'kt-menu__link-icon flaticon-suitcase',
            // iconName: '',
            color: 'navy',
            group: 'seventytwo',
            iconComponent: FeatherIcons.MonitorIcon,
        },
        {
            name: 'Capabilities',
            children: [
                { name: 'Capabilities', route: 'capabilities', type: 'capability' },
                { name: 'Platforms', route: 'platforms', type: 'platform' },
                { name: 'Services', route: 'service_items', type: 'service_item' },
            ],
            iconClass: 'kt-menu__link-icon flaticon2-layers-1',
            color: 'navy',
            group: 'seventytwo',
            iconComponent: FeatherIcons.BoxIcon,
        },
        {
            name: 'Staff',
            route: 'staff_members',
            iconClass: 'kt-menu__link-icon flaticon2-avatar',
            // iconName: '',
            color: 'navy',
            group: 'seventytwo',
            iconComponent: FeatherIcons.UserIcon,
        },
        {
            name: 'Clients',
            route: 'our_clients',
            iconClass: 'kt-menu__link-icon flaticon2-calendar-3',
            // iconName: '',
            color: 'navy',
            group: 'client',
            iconComponent: FeatherIcons.UsersIcon,
        },
        {
            name: 'Customers',
            route: 'customers',
            iconClass: 'kt-menu__link-icon flaticon2-calendar-3',
            // iconName: '',
            color: 'navy',
            group: 'client',
            iconComponent: FeatherIcons.UsersIcon,
        },
        {
            name: 'Testimonials',
            route: 'testimonials',
            iconClass: 'kt-menu__link-icon flaticon2-chat-2',
            // iconName: '',
            color: 'navy',
            group: 'client',
            iconComponent: FeatherIcons.MessageSquareIcon,
        },

        // {
        //     name: 'Services',
        //     route: 'services',
        //     iconClass: 'material-icons',
        //     iconName: 'devices_other',
        //     color: 'navy',
        // },
        // {
        //     name: 'Customers',
        //     type: 'customer',
        //     route: 'customers',
        //     iconClass: 'material-icons',
        //     iconName: 'perm_contact_calendar',
        //     color: 'navy',
        // },
        {
            name: 'Payments',
            route: 'payments',
            iconClass: 'kt-menu__link-icon flaticon2-list',
            // iconName: '',
            color: 'navy',
            group: 'client',
            iconComponent: FeatherIcons.DollarSignIcon,
        },
        {
            name: 'Enquiries',
            children: [
                { name: 'Enquiries', route: 'enquiries', type: 'enquiry' },
                { name: 'Subscribers', route: 'subscribers', type: 'subscriber' },
            ],
            iconClass: 'kt-menu__link-icon flaticon2-talk',
            // iconName: '',
            color: 'navy',
            group: 'client',
            iconComponent: FeatherIcons.MailIcon,
        },
        {
            name: 'Accounts',
            children: [
                { name: 'Users', route: 'users', type: 'user' },
                { name: 'Roles', route: 'roles', type: 'role' },
            ],
            iconClass: 'kt-menu__link-icon flaticon2-user',
            // iconName: '',
            color: 'navy',
            group: 'settings',
            iconComponent: FeatherIcons.LockIcon,
        },
        {
            name: 'Settings',
            children: [
                { name: 'Settings', route: 'settings', type: 'setting' },
                { name: 'Redirect URLs', route: 'redirect_urls', type: 'redirect_url' },
            ],
            iconClass: 'kt-menu__link-icon flaticon2-settings',
            // iconName: '',
            color: 'navy',
            group: 'settings',
            iconComponent: FeatherIcons.SettingsIcon,
        }
    ],
    defaultItem: 'Content',
}
